var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhoneSms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_853_48032",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_853_48032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3719 8.8975H13.9231V6.56417H10.3719V8.8975ZM10.5321 9.8975L9.88725 10.5423C9.78891 10.6406 9.67847 10.665 9.55591 10.6157C9.43325 10.5664 9.37191 10.4728 9.37191 10.3347V6.16933C9.37191 5.99578 9.42964 5.8515 9.54508 5.7365C9.66064 5.62161 9.80375 5.56417 9.97442 5.56417H14.3206C14.4912 5.56417 14.6344 5.62189 14.7499 5.73733C14.8654 5.85289 14.9231 5.996 14.9231 6.16667V9.29483C14.9231 9.46561 14.8654 9.60872 14.7499 9.72417C14.6344 9.83972 14.4912 9.8975 14.3206 9.8975H10.5321ZM4.66675 13.1667V13.7948C4.66675 13.8462 4.68814 13.8932 4.73091 13.9358C4.77358 13.9786 4.82058 14 4.87191 14H11.1282C11.1796 14 11.2266 13.9786 11.2692 13.9358C11.312 13.8932 11.3334 13.8462 11.3334 13.7948V13.1667H4.66675ZM4.66675 2.83333H11.3334V2.20517C11.3334 2.15383 11.312 2.10683 11.2692 2.06417C11.2266 2.02139 11.1796 2 11.1282 2H4.87191C4.82058 2 4.77358 2.02139 4.73091 2.06417C4.68814 2.10683 4.66675 2.15383 4.66675 2.20517V2.83333ZM4.87191 15C4.54047 15 4.25675 14.882 4.02075 14.646C3.78475 14.41 3.66675 14.1263 3.66675 13.7948V2.20517C3.66675 1.87372 3.78475 1.59 4.02075 1.354C4.25675 1.118 4.54047 1 4.87191 1H11.1282C11.4597 1 11.7434 1.118 11.9794 1.354C12.2154 1.59 12.3334 1.87372 12.3334 2.20517V4.141C12.3334 4.28267 12.2855 4.40145 12.1896 4.49733C12.0937 4.59311 11.9749 4.641 11.8332 4.641C11.6915 4.641 11.5727 4.59311 11.4771 4.49733C11.3813 4.40145 11.3334 4.28267 11.3334 4.141V3.83333H4.66675V12.1667H11.3334V11.859C11.3334 11.7173 11.3814 11.5986 11.4772 11.5027C11.5731 11.4069 11.6919 11.359 11.8336 11.359C11.9754 11.359 12.0941 11.4069 12.1897 11.5027C12.2855 11.5986 12.3334 11.7173 12.3334 11.859V13.7948C12.3334 14.1263 12.2154 14.41 11.9794 14.646C11.7434 14.882 11.4597 15 11.1282 15H4.87191Z",
    fill: "#9E4CD1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneSms);
export default __webpack_public_path__ + "static/media/Icon Phone SMS.fbf2df3f4b35f6fb6320675d1e596bb3.svg";
export { ForwardRef as ReactComponent };